import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See {@link SvgIcon} base class for all `propTypes`.
 *
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Function component rendering the icon for Working time today.
 *
 * @param {Object} [props] - The icon component properties.
 * @returns {React.ReactElement} A SVG element.
 *
 * @see SvgIcon
 * @example
 * <WorkingTimeTodayIcon width={12} />
 */
const WorkingTimeTodayIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M24,2.5a21.5,21.5,0,0,0,0,43h.06A21.5,21.5,0,1,0,24,2.5Zm0,38A16.5,16.5,0,1,1,
            40.5,24,16.5,16.5,0,0,1,24,40.5Zm9.47-23.82H28.82V16A3.69,3.69,0,0,0,28,13.59a3.06,
            3.06,0,0,0-2.33-1.11H22.34A3,3,0,0,0,20,13.59,3.7,3.7,0,0,0,19.17,16v.72H15a.92.92,
            0,0,0-.9.9v13.8a.9.9,0,0,0,.9.9H33.5a.9.9,0,0,0,.9-.9h0V17.58a.9.9,0,0,0-.9-.9ZM22.17,
            16a.74.74,0,0,1,.17-.48h3.35a.76.76,0,0,1,.13.44v.72H22.17Zm8.2,12.36H18.07V20.68h12.3Z`}
        />
    </SvgIcon>
)

WorkingTimeTodayIcon.defaultProps = defaultProps

export { WorkingTimeTodayIcon }
